import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { ErrorApiService } from '../services/api/error-api.service';

@Injectable()
export class AppErrorHandler implements ErrorHandler {
  private errorApiService: ErrorApiService;

  constructor(
    private injector: Injector
  ) { }

  async handleError(error: any) {
    if (!this.errorApiService) {
      this.errorApiService = this.injector.get(ErrorApiService);
    }

    await this.errorApiService.save(error.message).toPromise();
    throw error;
  }
}
